module.exports = __webpack_public_path__ + "static/newTagBackground-8cc0f05d743ca2a5feeae58614b1d9f0.jpg";